<template>
  <div class="Category">
    <el-popover
      placement="bottom-start"
      :append-to-body="false"
      trigger="hover"
      @show="popoverShow"
      v-model="show"
      popper-class="category-mega-popover"
    >
      <div class="mega-menu-container">
        <!-- 1. 左侧一级根分类栏 (宽约 220px) -->
        <div class="roots-sidebar">
          <el-scrollbar class="roots-scrollbar">
            <div
              v-for="item in navigator.roots"
              :key="item.id"
              @mouseenter="changeRoot(item)"
              @click="goToCategory(item)"
              :class="['root-item', { active: navigator.currentRootId === item.id }]"
            >
              <div class="item-left">
                <i :class="[getRootIcon(item), 'root-icon']"></i>
                <span class="root-name">{{ item.value }}</span>
              </div>
              <i class="el-icon-arrow-right chevron-icon"></i>
            </div>
          </el-scrollbar>

          <!-- 左侧底栏认证徽标 -->
          <div class="sidebar-footer">
            <i class="el-icon-circle-check auth-icon"></i>
            <span>专属企业协议目录认证</span>
          </div>
        </div>

        <!-- 2. 右侧二级/三级分类内容区 (宽约 800px) -->
        <div class="sub-panel">
          <!-- 面板顶部状态行 -->
          <div class="panel-header">
            <div class="header-left">
              <span class="current-title">{{ currentCategory ? currentCategory.value : '全部商品分类' }}</span>
              <button class="back-link" v-if="navigator.path.length > 1" @click="goBack" type="button">
                <i class="el-icon-back"></i> 返回上一级
              </button>
            </div>
            <div class="header-badge">
              <span>全线正品保障 · 支持专票月结</span>
            </div>
          </div>

          <!-- 分类分组内容区 -->
          <div class="panel-body" v-if="navigator.items.length">
            <div ref="items" class="groups-scroll-area">
              <div
                v-for="item in navigator.items"
                :key="item.id"
                class="category-group"
              >
                <!-- 分组标题列 -->
                <div class="group-title-col">
                  <span class="group-dot"></span>
                  <button class="group-name-btn" @click="goToCategory(item)" type="button" :title="item.value">
                    {{ item.value }}
                  </button>
                </div>

                <!-- 分组子类目标签列 -->
                <div class="group-items-col" v-if="item.children && item.children.length">
                  <button
                    v-for="child in item.children"
                    :key="child.id"
                    class="child-tag-btn"
                    @click="handleCategoryClick(child)"
                    type="button"
                    :title="child.value"
                  >
                    {{ child.value }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- 无下级类目提示 -->
          <div class="panel-empty" v-else>
            <i class="el-icon-folder-opened empty-icon"></i>
            <span>暂无下级类目</span>
          </div>

          <!-- 面板底部快速咨询横幅 -->
          <div class="panel-footer">
            <span class="footer-tip">需要批量集采询价或物料定制？</span>
            <div class="footer-action" @click="contactAdvisor">
              <span>联系专属采购经理快速核价</span>
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 3. 分类展开触发按钮 (挂在导航栏左侧的高阶深蓝按钮) -->
      <button class="category-trigger-btn" slot="reference" type="button">
        <i class="el-icon-menu menu-icon"></i>
        <span>全部商品分类</span>
        <i :class="['el-icon-arrow-down', 'arrow-icon', { 'is-open': show }]"></i>
      </button>
    </el-popover>
  </div>
</template>

<script>
const {
  createCategoryNavigator,
  enterCategory,
  goBackCategory,
  isLeafCategory,
  selectRootCategory,
} = require("@/util/categoryNavigator");

export default {
  name: "Category",
  props: {
    hierarchyList: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      navigator: createCategoryNavigator([]),
      show: false,
    };
  },
  computed: {
    pathText () {
      return this.navigator.path.map((item) => item.value).join(" > ");
    },
    currentCategory () {
      return this.navigator.path[this.navigator.path.length - 1];
    },
  },
  watch: {
    hierarchyList: {
      immediate: true,
      handler (value) {
        if (Array.isArray(value) && value.length) {
          this.navigator = createCategoryNavigator(value);
        }
      },
    },
  },
  methods: {
    popoverShow () {
      this.show = true;
      this.navigator = createCategoryNavigator(this.hierarchyList);
    },
    changeRoot (item) {
      this.navigator = selectRootCategory(this.navigator, item);
    },
    enter (item) {
      this.navigator = enterCategory(this.navigator, item);
    },
    handleCategoryClick (item) {
      if (item && (item.isLeaf || isLeafCategory(item))) {
        this.goToCategory(item);
      } else {
        this.enter(item);
      }
    },
    scrollItems (direction) {
      const container = this.$refs.items;
      if (container) {
        container.scrollTop += direction * 120;
      }
    },
    isLeafCategory (item) {
      return isLeafCategory(item);
    },
    goBack () {
      this.navigator = goBackCategory(this.navigator);
    },
    goToCategory (item) {
      this.show = false;
      this.$router.push("/mall/show/goodsList/1/all?categoryId=" + item.id);
    },
    contactAdvisor () {
      this.show = false;
      // 提示或与专属采购顾问浮动面板互动
      this.$message({
        message: "已为您接通专属企业采购经理，您可随时查看右下角联系专线。",
        type: "success",
        duration: 3000
      });
    },
    getRootIcon (item) {
      const name = item ? item.value : "";
      if (/电脑|办公|数码|智能|IT|硬件|网络/.test(name)) return 'el-icon-monitor';
      if (/日用|劳保|防护|安防|医疗|健康|保洁/.test(name)) return 'el-icon-first-aid-kit';
      if (/五金|工具|机电|建材|机械|电气/.test(name)) return 'el-icon-setting';
      if (/包装|耗材|仓储|物流|箱|袋/.test(name)) return 'el-icon-box';
      if (/食品|饮料|茶|水|生鲜|咖啡/.test(name)) return 'el-icon-dish';
      if (/电器|生活|家电/.test(name)) return 'el-icon-cpu';
      return 'el-icon-folder';
    }
  },
};
</script>

<style lang="less" scoped>
@import '../assets/css/var.less';

.Category {
  display: inline-block;

  // 触发按钮 (深蓝沉稳设计)
  .category-trigger-btn {
    height: 36px;
    padding: 0 16px;
    background-color: @brandPrimary;
    color: #ffffff;
    border: none;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 60, 144, 0.2);
    transition: all 0.2s ease;
    user-select: none;

    &:hover {
      background-color: @brandDark;
    }

    .menu-icon {
      font-size: 15px;
    }

    .arrow-icon {
      font-size: 12px;
      transition: transform 0.2s ease;

      &.is-open {
        transform: rotate(180deg);
      }
    }
  }

  // 大菜单主容器
  .mega-menu-container {
    width: 1020px;
    height: 480px;
    background-color: #ffffff;
    display: flex;
    overflow: hidden;
    box-sizing: border-box;

    // 1. 左侧一级根分类栏
    .roots-sidebar {
      width: 220px;
      flex-shrink: 0;
      background-color: #f8fafc;
      border-right: 1px solid @brandBorderLight;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;

      .roots-scrollbar {
        flex: 1;
        overflow-y: auto;
        padding: 8px;

        /deep/ .el-scrollbar__wrap {
          overflow-x: hidden;
        }

        .root-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 14px;
          border-radius: 8px;
          font-size: 13px;
          font-weight: 500;
          color: @brandTextBase;
          cursor: pointer;
          transition: all 0.15s ease;
          margin-bottom: 2px;
          user-select: none;

          .item-left {
            display: flex;
            align-items: center;
            gap: 8px;
            overflow: hidden;

            .root-icon {
              font-size: 15px;
              color: @brandTextLight;
              flex-shrink: 0;
            }

            .root-name {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .chevron-icon {
            font-size: 12px;
            color: #cbd5e1;
            flex-shrink: 0;
            transition: color 0.15s ease;
          }

          &:hover {
            background-color: #ffffff;
            color: @brandContainer;

            .root-icon {
              color: @brandContainer;
            }

            .chevron-icon {
              color: @brandContainer;
            }
          }

          &.active {
            background: linear-gradient(135deg, @brandPrimary 0%, @brandContainer 100%);
            color: #ffffff;
            box-shadow: 0 2px 8px rgba(0, 60, 144, 0.25);

            .root-icon {
              color: #ffffff;
            }

            .chevron-icon {
              color: #ffffff;
            }
          }
        }
      }

      .sidebar-footer {
        padding: 12px 14px;
        border-top: 1px solid @brandBorder;
        font-size: 11px;
        color: @brandTextMuted;
        display: flex;
        align-items: center;
        gap: 6px;
        background-color: #ffffff;

        .auth-icon {
          font-size: 14px;
          color: @brandSuccess;
        }
      }
    }

    // 2. 右侧分类内容面板
    .sub-panel {
      flex: 1;
      min-width: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 18px 24px;
      box-sizing: border-box;

      .panel-header {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        padding-bottom: 12px;
        border-bottom: 1px solid @brandBorderLight;

        .header-left {
          display: flex;
          align-items: baseline;
          gap: 12px;

          .current-title {
            font-size: 16px;
            font-weight: 700;
            color: @brandTextDark;
            letter-spacing: -0.01em;
          }

          .back-link {
            border: none;
            background: transparent;
            color: @brandContainer;
            font-size: 12px;
            cursor: pointer;
            padding: 0;

            &:hover {
              text-decoration: underline;
            }
          }
        }

        .header-badge {
          display: inline-flex;
          align-items: center;
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 11px;
          font-weight: 500;
          background-color: @brandLight;
          color: @brandPrimary;
          border: 1px solid rgba(0, 60, 144, 0.15);
        }
      }

      .panel-body {
        flex: 1;
        min-height: 0;
        padding: 12px 0 8px;
        overflow-y: auto;

        .groups-scroll-area {
          height: 100%;
          overflow-y: auto;
          padding-right: 12px;
          scrollbar-width: thin;

          .category-group {
            display: flex;
            align-items: flex-start;
            gap: 16px;
            margin-bottom: 14px;

            .group-title-col {
              width: 90px;
              flex-shrink: 0;
              display: flex;
              align-items: center;
              gap: 6px;
              padding-top: 4px;

              .group-dot {
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background-color: @brandContainer;
                flex-shrink: 0;
              }

              .group-name-btn {
                border: none;
                background: transparent;
                font-size: 12px;
                font-weight: 700;
                color: @brandTextDark;
                text-align: left;
                cursor: pointer;
                padding: 0;
                line-height: 1.3;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                &:hover {
                  color: @brandContainer;
                }
              }
            }

            .group-items-col {
              flex: 1;
              display: flex;
              flex-wrap: wrap;
              gap: 6px;

              .child-tag-btn {
                border: 1px solid #f1f5f9;
                background-color: #f8fafc;
                color: #475569;
                font-size: 12px;
                padding: 4px 10px;
                border-radius: 4px;
                cursor: pointer;
                transition: all 0.15s ease;
                white-space: nowrap;

                &:hover {
                  background-color: @brandLight;
                  color: @brandPrimary;
                  border-color: rgba(0, 60, 144, 0.2);
                  transform: translateY(-1px);
                }
              }
            }
          }
        }
      }

      .panel-empty {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: @brandTextLight;
        font-size: 13px;
        gap: 8px;

        .empty-icon {
          font-size: 36px;
          color: #cbd5e1;
        }
      }

      .panel-footer {
        padding-top: 12px;
        border-top: 1px solid @brandBorderLight;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;

        .footer-tip {
          color: @brandTextLight;
        }

        .footer-action {
          color: @brandContainer;
          font-weight: 500;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 4px;
          transition: all 0.15s ease;

          &:hover {
            color: @brandPrimary;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
// 全局穿透 popover 容器样式 (确保实心不透明与精确层级)
.el-popover.category-mega-popover {
  margin: 0 !important;
  padding: 0 !important;
  background-color: #ffffff !important;
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 16px 36px rgba(0, 40, 100, 0.16) !important;
  overflow: hidden !important;
  z-index: 2500 !important;

  .popper__arrow {
    display: none !important;
  }

  .mega-menu-container {
    background-color: #ffffff !important;
  }

  .roots-sidebar {
    background-color: #f8fafc !important;
  }

  .sub-panel {
    background-color: #ffffff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Category.vue